<template>
  <!-- Navbar -->
  <nav
    id="main_nav"
    class="main-header navbar navbar-expand bg-warning navbar-light border-bottom"
  >
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          style="cursor:pointer"
          @click="showMenu()"
          id="barsIcon"
          class="nav-link"
          data-widget="pushmenu"
          ><i class="fa fa-bars"></i
        ></a>
      </li>
    </ul>

    <!-- SEARCH FORM -->

    <!-- Right navbar links -->
    <ul class="navbar-nav mr-auto top_icons">
      <!-- Messages Dropdown Menu -->

      <li id="admin_profile" class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown">
          <i class="fa fa-user"></i>
          {{ username }}
        </a>
        <ul>
          <li @click="showModal()">
            <a>
              <i class="fa fa-edit"></i>
              ویرایش پروفایل</a
            >
          </li>
           <li @click="showPass()">
            <a>
              <i class="fa fa-key"></i>
              تغییر رمز عبور</a
            >
          </li>

          <li @click="singOut()">
            <a>
              <i class="fa fa-sign-out-alt"></i>
              خروج</a
            >
          </li>
        </ul>
      </li>
    </ul>
    <b-modal
      ref="profile_modal"
      hide-footer
      v-model="profile_modal"
      id="profile_modal"
      title="ویرایش اطلاعات"
    >
      <b-form class="hozeh_form" @submit.prevent="submit">
        <b-form-group label="نام* :">
          <b-form-input
            :value="user != null ? user.name : ''"
            name="name"
            placeholder="مانند ادمین"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="نام کاربری* :">
          <b-form-input
            :value="user != null ? user.username : ''"
            name="username"
            placeholder="مانند admin"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="ایمیل :">
          <b-form-input
            :value="user != null ? user.email : ''"
            name="email"
            placeholder="مانند admin@info.com"
          ></b-form-input>
        </b-form-group>
        <p class="badge badge-info">
          <i class="fa fa-info"></i>
          در صورت خالی بودن مقدار قبلی در نظر گرفته میشود
        </p>

        <div class="form_btn">
          <b-button type="submit" variant="primary">
            ویرایش
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      ref="changePass"
      hide-footer
      v-model="changePass"
      id="changePass"
      title="تغییر پسورد"
    >
      <b-form @submit.prevent="submitPass">
        <b-form-group label="رمز عبور :">
          <b-form-input
            name="password"
            placeholder="مانند admin123#"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="تکرار رمز عبور :">
          <b-form-input
            name="password_confirmation"
            placeholder="تکرار رمز عبور را وارد کنید"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="رمز عبور قبلی :">
          <b-form-input
            name="old_password"
          ></b-form-input>
        </b-form-group>
        
        <div class="form_btn">
          <b-button type="submit" variant="primary">
            ویرایش
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </nav>
</template>
<script>
import { BForm, BFormGroup, BFormInput, BButton, BModal } from "bootstrap-vue";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal
  },
  methods: {
    showPass(){
      this.changePass = true;

    },
    showModal() {
      this.profile_modal = true;
    },
    singOut() {
      this.$cookie.delete("adminAuthorization");
      this.$router.push("/admin/login");
    },
    showMenu() {
      if (!document.getElementById("sideBar").classList.contains("showMenu")) {
        document.getElementById("sideBar").classList.add("showMenu");
      }
    },
    submitPass(e){
          const form_data = new FormData(e.target);
      form_data.append("_method", "PUT");
      this.$axios
        .post("/admin/password", form_data)
        .then((response) => {
          this.$root.notify(response.data.message, "success");
          this.$refs["changePass"].hide();
        })
        .catch((error) => {
          this.$root.notify(error);
        });
    },
    submit(e) {
      const form_data = new FormData(e.target);
      form_data.append("_method", "PATCH");
      this.$axios
        .post("/admin/profile", form_data)
        .then((response) => {
          this.$root.notify(response.data.message, "success");
          this.$refs["profile_modal"].hide();
        })
        .catch((error) => {
          this.$root.notify(error);
        });
    }
  },
  computed: {
    username() {
      return localStorage.getItem("username");
    }
  },
  data() {
    return {
      profile_modal: false,
      user: null,
      changePass:false
    };
  },
  created() {
    if (this.user == null) {
      this.$axios
        .get("/admin/profile")
        .then((res) => {
          this.user = res.data.data;
        })
        .catch((error) => {
          this.$root.notify(error);
        });
    }
  }
};
</script>
<style scoped>
.wideContent {
  margin-right: 5% !important;
}
.top_icons li {
  cursor: pointer;
}
#admin_profile {
  position: relative;
}
#admin_profile ul {
  position: absolute;
  background: #f4f4f4;
  width: 153px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  left: -4px;
  height: 0px;
  list-style-type: none;
  transition: 0.5s;
  overflow: auto;
  top: 30px;
}
#admin_profile ul li {
  padding: 10px;
}
#admin_profile:hover ul {
  height: auto;
}
#admin_profile ul li:hover {
  background: #d0d0d0;
}
ul.nav.nav-pills.nav-sidebar.flex-column li {
  margin-bottom: 4px;
}
</style>
